import { render } from "./assementsGrid.vue?vue&type=template&id=27964eda"
import script from "./assementsGrid.vue?vue&type=script&lang=js"
export * from "./assementsGrid.vue?vue&type=script&lang=js"

import "./assementsGrid.vue?vue&type=style&index=0&id=27964eda&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__